module.exports = __webpack_public_path__ + "static/media/registerIcon.aeca6367.svg";